import type { TextProps } from '@chakra-ui/react'
import { Skeleton, Text } from '@chakra-ui/react'

export type StatValueProps = {
  isLoading?: boolean
} & TextProps

export const StatValue = ({ children, sx, isLoading, ...rest }: StatValueProps) => {
  return (
    <Skeleton
      isLoaded={!isLoading}
      fadeDuration={1}
      minHeight={6}
      lineHeight={1}
    >
      <Text fontSize='3xl' fontWeight='medium' {...rest}>
        {children}
      </Text>
    </Skeleton>
  )
}
